import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useDataModel, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { DataModelSchema } from 'schemas';
import DataModelFormDumb from './DataModelFormDumb';
import { CircularProgress, Backdrop } from '@mui/material';


const DataModelEditSmart = (props) => {
  const { match: { params } } = props;
  const { projectId, dataModel } = params;
  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);
  const history = useHistory();
  const {
    cleanUpMessage,
    error,
    success,
    putDataModel,
    getDataModel,
    data,
    isLoaded
  } = useDataModel();

  const [defaultValues, setDefaultValues] = useState({
    name: '',
    project: projects[0].value,
    additionalVariables: '',
    language: 'json',
  });

  const baseUrl = (projectId) => {
    const project = projects.find(p => Number(p.value) === Number(projectId));
    return project.base_url;
  }

  const findProject = (project) => {
    return projects.find(p => Number(p.value) === Number(project));
  }

  useEffect(() => {
    if (!!success.put) history.push(ROUTES.DATA_MODEL_LIST);
    else if (!!success.get) handleData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.get, success.put]);

  useLayoutEffect(() => {
    const query = {
      baseUrl: baseUrl(projectId),
      file: dataModel
    }
    getDataModel({ query});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseAlert = () => cleanUpMessage();

  const handleEdit = (data) => {
    const dataModel = new DataModelSchema();
    data.name = `${data.name}.${data.language}`;
    dataModel.setValues(data);
    const project = findProject(data.project);
    dataModel.values.baseUrl = project.base_url;
    dataModel.values.fromEdit = true;
    putDataModel({
      body: dataModel.getValues()
    });
  };

  function handleData() {
    const nameSplit = dataModel.split('.');
    let additionalVariables = data;
    if (nameSplit[1] === 'json') {
      additionalVariables = JSON.stringify(data, null, 2);
    }
    setDefaultValues({
      name: nameSplit[0],
      project: Number(projectId),
      additionalVariables,
      language: (nameSplit[1] === 'md') ? 'json' : nameSplit[1]
    })
  };

  return (
    <>
      { error.get ?
        (
          <ErrorScreen />
        ): isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (data && projects) ?
        (
          <DataModelFormDumb
            defaultValues={defaultValues}
            handleOnSubmit={handleEdit}
            isEdit={true}
          />
        )
        :(
          <ErrorScreen />
        )
      }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="dataModelCreate.components.alert.error" />
    </>
  );
};

export default withRequest(withRouter(DataModelEditSmart));
